/**
 * Outlets API — CRUD for outlets under a business.
 */

import { api } from "./client";
import type { Outlet } from "../types/models";

export interface CreateOutletRequest {
  business_id: string;
  name: string;
  bill_number_prefix?: string;
  address?: string;
  city?: string;
  state?: string;
  pincode?: string;
  phone?: string;
  email?: string;
  gstin?: string;
  fssai_no?: string;
  operating_hours?: Record<string, { open: string; close: string; closed: boolean }>;
  eod_mode?: string;
  eod_close_mode?: string;
  slug?: string;
  takeaway_public?: boolean;
  takeaway_whatsapp_phone?: string;
  timezone?: string;
  date_format?: string;
  time_format?: string;
  is_default?: boolean;
  hide_kot?: boolean;
  enable_barcode_scanner?: boolean;
  disable_gst?: boolean;
  settings?: Record<string, any>;
  country_code?: string;
  tax_regime?: string;
  tax_number?: string;
  bill_year_mode?: string;
}

export interface UpdateOutletRequest {
  name?: string;
  bill_number_prefix?: string;
  address?: string;
  city?: string;
  state?: string;
  pincode?: string;
  phone?: string;
  email?: string;
  gstin?: string;
  fssai_no?: string;
  operating_hours?: Record<string, { open: string; close: string; closed: boolean }>;
  eod_mode?: string;
  eod_close_mode?: string;
  slug?: string;
  takeaway_public?: boolean;
  takeaway_whatsapp_phone?: string;
  timezone?: string;
  date_format?: string;
  time_format?: string;
  active?: boolean;
  is_default?: boolean;
  hide_kot?: boolean;
  enable_barcode_scanner?: boolean;
  disable_gst?: boolean;
  settings?: Record<string, any>;
  country_code?: string;
  tax_regime?: string;
  tax_number?: string;
  bill_year_mode?: string;
}

export const outletsApi = {
  /** List outlets for a business */
  listOutlets(businessId: string): Promise<Outlet[]> {
    return api.get<Outlet[]>("/outlets", { business_id: businessId });
  },

  /** Get a single outlet */
  getOutlet(outletId: string): Promise<Outlet> {
    return api.get<Outlet>(`/outlets/${outletId}`);
  },

  /** Create a new outlet */
  createOutlet(data: CreateOutletRequest): Promise<Outlet> {
    return api.post<Outlet>("/outlets", data);
  },

  /** Update an outlet */
  updateOutlet(outletId: string, data: UpdateOutletRequest): Promise<Outlet> {
    return api.put<Outlet>(`/outlets/${outletId}`, data);
  },

  /** Delete an outlet */
  deleteOutlet(outletId: string): Promise<void> {
    return api.del(`/outlets/${outletId}`);
  },
};
